import { useTranslation } from "react-i18next"
import { useAPIResources, useQueryState } from "@/hooks"
import { tagsAPI } from "@/utils"
import { MultiFilter } from "./MultiFilter"

const filterName = "tgs"

export function TagsFilter({ items = [] }: { items?: string[] }) {
  const { t } = useTranslation("tags")
  const { data: { data = [] } = {}, isLoading } = useAPIResources(tagsAPI, {
    where: { category: { $in: ["work-style", "personal-info", "pets", "food", "sports"] } },
  })
  const selectItems = [
    ...items.map((tag) => ({ value: tag, label: t(tag) })),
    ...data.map((tag) => ({ value: tag.id, label: t(tag.id) })),
  ].sort((a, b) => a.label.localeCompare(b.label))

  const [value, setValue] = useQueryState<string[]>(filterName, { multi: true })

  return (
    <MultiFilter
      label={t("Filter by Tags")}
      items={selectItems}
      loading={isLoading}
      value={value ?? []}
      setValue={(value) => setValue(value?.length > 0 ? value : undefined)}
    />
  )
}

TagsFilter.filterName = filterName

TagsFilter.useValue = () => {
  const [value] = useQueryState<string[]>(filterName, { multi: true })
  return value ?? []
}
